'use client';
export const getTabbableItems = (container, optionsOnly = false) => {
    return [...container.querySelectorAll(optionsOnly ? '[role=option]' : 'input, button')];
};
export const tab = (direction, container) => {
    const items = getTabbableItems(container);
    const focusedItemIndex = items.findIndex((item) => item === document.activeElement);
    if (focusedItemIndex >= 0 && focusedItemIndex < items.length) {
        const newIndex = direction === 'forward' ? focusedItemIndex + 1 : focusedItemIndex - 1;
        items[newIndex]?.focus();
    }
};
